module.exports = __webpack_public_path__ + "media/theme/logo7-f5a34c4f.png";